// extracted by mini-css-extract-plugin
export default {"tableRow":"ConsumersUsagePage_tableRow__Bp2GC"};